module.exports = __webpack_public_path__ + "static/media/jin_topfdb7f538bbe66dcee67506bf01181351.webp";